import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Parks = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.722 30.1c-.3.398-.899.398-1.298 0L32.342 20.021l-5.49 5.288 9.483 9.28c.3.299.3.897 0 1.296-.4.3-.898.4-1.298 0L24.856 26.01l-10.98-10.876L1.596 27.206c-.4.4-.898.4-1.298 0-.399-.3-.399-.898 0-1.297l12.877-12.771c.3-.3.899-.3 1.198 0l10.98 10.875 6.19-5.986c.399-.3.898-.3 1.197 0l10.781 10.676c.599.498.599 1.097.2 1.396Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.356 9.646a2.683 2.683 0 0 0-2.695 2.693 2.683 2.683 0 0 0 2.695 2.694 2.683 2.683 0 0 0 2.696-2.694 2.683 2.683 0 0 0-2.696-2.693Zm-4.392 2.594c0-2.495 1.997-4.39 4.392-4.39a4.366 4.366 0 0 1 4.392 4.39c0 2.394-1.996 4.39-4.392 4.39-2.395.1-4.392-1.896-4.392-4.39Z"
  }));
});
Parks.displayName = 'Parks';
Parks.defaultProps = {
  'aria-label': 'Parks'
};
export default Parks;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Parks.js
// module id = 3683
// module chunks = 11